const mediaTypes = {
  userAvatar: 'userAvatar',
  inspirationImage: 'inspirationImage',
  product: 'product',
  showcaseBanner: 'showcaseBanner',
};

export default mediaTypes;
